import { Badge } from "@volca/ui/components/ui/badge";
import {
  SimpleSidebar,
  SimpleSidebarHeader,
} from "@volca/ui/components/ui/simple-sidebar";
import { roleBadgeVariant, roleLabel } from "@/user/constants";
import {
  PersonAccessEditor,
  type PersonAccessEditorProps,
} from "./person-access-editor";

export const PersonAccessDrawer = (props: PersonAccessEditorProps) => (
  <SimpleSidebar
    aria-label={`Access for ${props.person.name}`}
    className="motion-reduce:transition-none!"
  >
    <SimpleSidebarHeader
      className="px-6"
      title={props.person.name}
      description={props.person.email}
      actions={
        <Badge
          variant="secondary"
          color={roleBadgeVariant(props.person.role)}
          size="sm"
          className="shrink-0"
        >
          {roleLabel(props.person.role)}
        </Badge>
      }
      onClose={props.onCancel}
    />
    <PersonAccessEditor {...props} />
  </SimpleSidebar>
);
